<template>
  <div class="h-100 d-block">
    <vue-apex-charts
      type="bar"
      :options="chartOptions"
      :series="series"
      width="100%"
      height="100%"
    />
  </div>
</template>
<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'BarWithMarkers',
  components: {
    VueApexCharts,
  },
  props: {
    seriesData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      series: [],
      chartOptions: {
        chart: {
          height: 350,
          type: 'bar',
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        colors: ['#5bc699'],
        dataLabels: {
          formatter(val, opt) {
            const { goals } = opt.w.config.series[opt.seriesIndex].data[opt.dataPointIndex]

            if (goals && goals.length) {
              return `${val} / ${goals[0].value}`
            }
            return val
          },
        },
        legend: {
          show: true,
          showForSingleSeries: true,
          customLegendItems: ['Açık İş Emri', 'Kapasite'],
          markers: {
            fillColors: ['#5bc699', '#e34242'],
          },
        },
      },
    }
  },
  watch: {
    seriesData: 'setData',
    // categoriesData: 'setData',
    // colorsData: 'setData',
  },
  created() {
    this.setData()
  },
  methods: {
    setData() {
      this.series = this.seriesData
      // this.chartOptions.xaxis.categories = this.categoriesData
      // this.chartOptions.colors = this.colorsData
    },
  },
}
</script>
